module.exports = __webpack_public_path__ + "img/paid-up-capital.13ab4789.svg";